import { config } from './environment';

interface ServerConfig {
  allow_past_bookings: boolean;
  billing_charging_active: boolean;
  stripe_publishable_key: string;
}

const defaults: ServerConfig = {
  allow_past_bookings: false,
  billing_charging_active: false,
  stripe_publishable_key: '',
};

let cached: ServerConfig | null = null;
let cachedAt = 0;
const CACHE_TTL_MS = 60_000; // 1 minute

export async function getServerConfig(): Promise<ServerConfig> {
  if (cached && Date.now() - cachedAt < CACHE_TTL_MS) return cached;
  try {
    const res = await fetch(`${config.apiBaseUrl}/config`);
    cached = res.ok ? { ...defaults, ...(await res.json()) } : defaults;
    cachedAt = Date.now();
  } catch {
    cached = defaults;
    cachedAt = Date.now();
  }
  return cached!;
}
